import React from 'react'

const MonthNav = ({
    title,
    prev, 
    next
}) => {

    return <div className="container-fluid d-flex align-items-center justify-content-center py-3">
        <div className="ms-4 pe-4">
        <button 
            className="btn btn-light text-dark border bg-white p-1 me-2"
            onClick={() => prev()}
            style={{
                borderRadius: '50%',
                height: '25px',
                width: '25px',
                lineHeight: '1.1rem'
            }}><i className="fas fa-chevron-left"></i></button>
        </div>
        <h4 className="flex-fill text-center m-0">{title}</h4>
        <div className="me-4 pe-4">
        <button 
            className="btn btn-light text-dark border bg-white p-1 ms-2"
            onClick={() => next()}
            style={{
                borderRadius: '50%',
                height: '25px',
                width: '25px',
                lineHeight: '1.1rem'
            }}><i className="fas fa-chevron-right"></i></button>
        </div>
            
    </div>
}

export default MonthNav